import React, { PureComponent } from "react"

/* Constants */
import { utils } from "../constants"


/* Палитра салюта — золото с тёплыми искрами, чтобы совпадать с плашкой джекпота */
const COLORS = ["#FFD643", "#FFF3B0", "#FFA62B", "#FFFFFF", "#FFC300", "#FF6B35"]

/* Физика частиц (в кадрах при 60 fps, dt нормирован на 16.67 мс) */
const GRAVITY = 0.038
const FRICTION = 0.982

/* Салют идёт на полную первые 5 секунд — после них появляется подсказка и оверлей ждёт нажатия.
   В ожидании залпы становятся редкими и одиночными, чтобы экран не замирал насовсем */
const CELEBRATION = 5000
const SPAWN_EVERY = 420
const SPAWN_IDLE = 1700


/* Component JackpotWin — полноэкранная анимация выигрыша джекпота */
class JackpotWin extends PureComponent {

    canvas = null
    ctx = null

    raf = null
    rockets = []
    particles = []

    lastTime = 0
    lastSpawn = 0

    readyTimer = null
    closeTimer = null

    constructor() {
        super()

        this.state = {
            /* ready — салют отыграл, дальше игрок закрывает оверлей сам */
            ready: false,
            hiding: false
        }
    }


    componentDidMount = () => {

        this.resize()
        window.addEventListener("resize", this.resize)

        /* Первый залп — сразу, без ожидания интервала, иначе экран пустует полсекунды */
        this.launch(0.5)
        this.launch(0.22)
        this.launch(0.78)

        this.lastTime = performance.now()
        this.lastSpawn = this.lastTime
        this.raf = requestAnimationFrame(this.loop)

        const duration = this.props.celebration || CELEBRATION
        this.readyTimer = setTimeout(() => this.setState({ ready: true }), duration)
    }


    componentWillUnmount = () => {
        window.removeEventListener("resize", this.resize)
        if (this.raf) cancelAnimationFrame(this.raf)
        clearTimeout(this.readyTimer)
        clearTimeout(this.closeTimer)
    }


    /* Закрытие: только после салюта и только по нажатию — случайный тап анимацию не обрывает.
       Сначала затухание, потом уже снимаем компонент */
    close = () => {

        if (this.state.hiding || !this.state.ready) return

        this.setState({ hiding: true })

        this.closeTimer = setTimeout(() => {
            const { onClose } = this.props
            if (onClose) onClose()
        }, 500)
    }


    /* Канвас тянется под размер окна с учётом плотности пикселей */
    resize = () => {

        if (!this.canvas) return

        const dpr = Math.min(window.devicePixelRatio || 1, 2)

        this.width = this.canvas.clientWidth
        this.height = this.canvas.clientHeight

        this.canvas.width = Math.floor(this.width * dpr)
        this.canvas.height = Math.floor(this.height * dpr)

        this.ctx = this.canvas.getContext("2d")
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    }


    /* Запуск ракеты: взлетает из-за нижней кромки и взрывается на своей высоте */
    launch = (at = Math.random()) => {

        if (!this.width || !this.height) return

        const x = this.width * (0.12 + at * 0.76)
        const targetY = this.height * (0.16 + Math.random() * 0.3)

        this.rockets.push({
            x,
            y: this.height + 10,
            px: x,
            py: this.height + 10,
            vx: (Math.random() - 0.5) * 1.1,
            vy: -(9 + Math.random() * 3.5),
            targetY,
            color: COLORS[Math.floor(Math.random() * COLORS.length)]
        })
    }


    /* Взрыв: кольцо частиц со случайным разбросом скорости */
    explode = (x, y, color) => {

        const count = 70 + Math.floor(Math.random() * 40)

        /* Часть залпов одноцветная, часть — разноцветная: так серия не выглядит однообразной */
        const mono = Math.random() > 0.45

        for (let i = 0; i < count; i++) {

            const angle = (Math.PI * 2 * i) / count + Math.random() * 0.12
            const speed = 1.8 + Math.random() * 5.4
            const life = 55 + Math.random() * 55

            this.particles.push({
                x,
                y,
                px: x,
                py: y,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                life,
                maxLife: life,
                size: 1 + Math.random() * 1.6,
                color: mono ? color : COLORS[Math.floor(Math.random() * COLORS.length)]
            })
        }
    }


    loop = (time) => {

        this.raf = requestAnimationFrame(this.loop)

        if (!this.ctx) return

        /* Нормируем шаг к 60 fps и режем скачки после фоновой вкладки */
        const dt = Math.min((time - this.lastTime) / 16.67, 3)
        this.lastTime = time

        const { ready, hiding } = this.state

        if (!hiding && time - this.lastSpawn > (ready ? SPAWN_IDLE : SPAWN_EVERY)) {
            this.lastSpawn = time
            this.launch()
            if (!ready && Math.random() > 0.55) this.launch()
        }

        const ctx = this.ctx
        ctx.clearRect(0, 0, this.width, this.height)
        ctx.globalCompositeOperation = "lighter"

        /* Ракеты */
        for (let i = this.rockets.length - 1; i >= 0; i--) {

            const r = this.rockets[i]

            r.px = r.x
            r.py = r.y
            r.x += r.vx * dt
            r.y += r.vy * dt
            r.vy += GRAVITY * 6 * dt

            ctx.globalAlpha = 1
            ctx.strokeStyle = r.color
            ctx.lineWidth = 2
            ctx.beginPath()
            ctx.moveTo(r.px, r.py)
            ctx.lineTo(r.x, r.y)
            ctx.stroke()

            if (r.vy >= 0 || r.y <= r.targetY) {
                this.explode(r.x, r.y, r.color)
                this.rockets.splice(i, 1)
            }
        }

        /* Частицы взрыва */
        for (let i = this.particles.length - 1; i >= 0; i--) {

            const p = this.particles[i]

            p.px = p.x
            p.py = p.y
            p.vx *= Math.pow(FRICTION, dt)
            p.vy = p.vy * Math.pow(FRICTION, dt) + GRAVITY * dt
            p.x += p.vx * dt
            p.y += p.vy * dt
            p.life -= dt

            if (p.life <= 0) {
                this.particles.splice(i, 1)
                continue
            }

            /* Хвост рисуем отрезком от прошлой позиции — дешевле и чище, чем накопление кадров */
            ctx.globalAlpha = Math.max(p.life / p.maxLife, 0)
            ctx.strokeStyle = p.color
            ctx.lineWidth = p.size
            ctx.beginPath()
            ctx.moveTo(p.px, p.py)
            ctx.lineTo(p.x, p.y)
            ctx.stroke()
        }

        ctx.globalAlpha = 1
        ctx.globalCompositeOperation = "source-over"
    }


    /* Плашка джекпота на столе считает пул в долларах — анимация показывает ту же сумму.
       Валюта игрока остаётся в истории; сюда она попадает только если бэкенд не прислал usd */
    _sum = () => {

        const { amount, usd, currency } = this.props

        if (usd !== null && usd !== undefined && !isNaN(parseFloat(usd))) {
            const [whole, fraction] = parseFloat(usd).toFixed(2).split(".")
            return `$ ${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${fraction}`
        }

        if (amount !== null && amount !== undefined) {
            return utils.convertor(amount, currency || "USD")
        }

        return null
    }


    render = () => {

        const { demo } = this.props
        const { ready, hiding } = this.state

        const sum = this._sum()

        return (
            <div className={`jackpot-win ${ready ? "jackpot-win-ready" : ""} ${hiding ? "jackpot-win-hiding" : ""}`} onClick={() => this.close()}>

                <div className="jackpot-win-glow" />

                <canvas className="jackpot-win-canvas" ref={ref => this.canvas = ref} />

                <div className="jackpot-win-content">

                    <div className="jackpot-win-top">ВЫ ВЫИГРАЛИ</div>

                    <div className="jackpot-win-title" data-text="JACKPOT">
                        <span>JACKPOT</span>
                    </div>

                    {sum ? <div className="jackpot-win-sum">{sum}</div> : null}

                    {demo ?
                        <div className="jackpot-win-demo">
                            Выигрыш не зачисляется на тестовом аккаунте.<br />
                            Играйте на реальные деньги, чтобы забрать джекпот на свой счёт.
                        </div>
                        : null}

                    {ready ? <div className="jackpot-win-hint">Нажмите, чтобы продолжить</div> : null}

                </div>

            </div>
        )
    }

}

export default JackpotWin
